module.exports = "<footer class=\"app-footer\">\n  \n<div class=\"row\">\n  <div class=\"col-xs-12\">\n    <div class=\"footer-copyright\">\n      <br/>\n      MedPlus MP - Oficina Virtual Usuarios\n    </div>\n  </div>\n</div>    \n  \n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/layout-footer/layout-footer.component.html
// module id = ../../../../../src/app/shared/components/layout-footer/layout-footer.component.html
// module chunks = main